export enum ReviewSortEnum {
    MOST_HELPFUL = 'mostHelpful',
    NEWEST = 'newest',
    HIGHEST_RATING = 'highestRating',
    LOWEST_RATING = 'lowestRating',
}
